module.exports = __webpack_public_path__ + "img/132.8.864acd42.png";